<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {}
  },
  created() {
    console.log('测试发布是否成功----2020-9-15')
    this.$store.dispatch('getParams')
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        const checkRoutes = ['/policyDeclare/highLevel']
        if (checkRoutes.includes(window.location.pathname)) {
          // eslint-disable-next-line func-names
          // window.onbeforeunload = function () {
          //   return '您可能有数据没有保存'
          // }
        } else {
          // window.onbeforeunload = undefined
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
html,
body,
#app {
  height: 100vh;
  font-family: Avenir, Helvetica, Arial, sans-serif !important;
  // overflow-x: hidden;
  .tooltip_box {
    .frist_icon {
      display: block;
    }

    .last_icon {
      display: block;
    }
  }
}

/* #app {
  font-family: MicrosoftYaHeiUI MicrosoftYaHeiUI Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>
